import { render, staticRenderFns } from "./exitFullScreen.vue?vue&type=template&id=71fd8e38&scoped=true&"
import script from "./exitFullScreen.vue?vue&type=script&lang=js&"
export * from "./exitFullScreen.vue?vue&type=script&lang=js&"
import style0 from "./exitFullScreen.vue?vue&type=style&index=0&id=71fd8e38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fd8e38",
  null
  
)

export default component.exports